import React from 'react';
import { Flex } from '@components/Flex';
import { CopyrightText, StyledFooterLink } from './Footer.styles';
import { useTranslation } from 'react-i18next';

interface FooterPrivacyMenuProps {
  id: string;
}

export const FooterPrivacyMenu: React.FC<FooterPrivacyMenuProps> = ({ id }) => {
  const { t } = useTranslation('header');

  return (
    <>
      <Flex alignItems="center" style={{ columnGap: '4px' }}>
        <StyledFooterLink id={`footer2Terms${id}`} href="https://withjoy.com/eula" variant="footer" hasSpan={false}>
          {t('footer.terms')}
        </StyledFooterLink>
        <CopyrightText variant="navParent18" tagName="span">
          &
        </CopyrightText>
        <StyledFooterLink id={`footer2privacy${id}`} href="https://privacy.withjoy.com" variant="footer" hasSpan={false}>
          {t('footer.privacy')}
        </StyledFooterLink>
      </Flex>
      <StyledFooterLink
        id={`footerPrivacyNotice${id}`}
        variant="footer"
        href="https://privacy.withjoy.com/privacy-policy#california-privacy-notice"
        noreferrer
        noopener
      >
        {t('footer.californiaPrivacyNotice')}
      </StyledFooterLink>
      <StyledFooterLink id={`footerDonotShareNotice${id}`} variant="footer" href="https://privacy.withjoy.com/opt-out" noreferrer noopener>
        {t('footer.doNotShareInformation')}
      </StyledFooterLink>
    </>
  );
};
